export const generateOrganizationSchema = ({
  locale,
  logo,
  socialLinks,
  email,
  phone,
}) => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "ALHOME",
    url: `${process.env.NEXT_CANONICAL_URL}/${locale}`,
    logo: logo,
    sameAs: socialLinks?.map((item) => item.url),
    contactPoint: {
      "@type": "ContactPoint",
      telephone: phone,
      email: email,
      contactType: "Customer Service",
      areaServed: "SA",
      availableLanguage: ["English", "Arabic"],
    },
  };
};

export const generateProductSchema = ({
  name,
  description,
  brand,
  locale,
  slug,
  images,
  sku,
  formattedPrice,
  isStockStatus,
  averageRating,
}) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name,
  description,
  brand,
  url: `${process.env.NEXT_CANONICAL_URL}/${locale}/collections/${slug}`,
  image: images?.[0]?.imageURI,
  sku,
  offers: {
    "@type": "Offer",
    priceCurrency: "SAR",
    price: formattedPrice,
    availability: isStockStatus ? "InStock" : "OutOfStock",
  },
  aggregateRating: averageRating,
});

export const generateCategorySchema = ({
  name,
  locale,
  slug,
  breadCrumbs,
}) => ({
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: name || breadCrumbs?.[breadCrumbs.length - 1]?.label,
  url: `${process.env.NEXT_CANONICAL_URL}/${locale}/collections/${slug}`,
  breadcrumb: {
    "@type": "BreadcrumbList",
    itemListElement: breadCrumbs?.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@id": `${process.env.NEXT_CANONICAL_URL}/${locale}${item.url}`,
        name: item.label,
      },
    })),
  },
});

export const generateBreadcrumbSchema = ({ locale, breadcrumbs }) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: breadcrumbs?.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    item: {
      "@id": `${process.env.NEXT_CANONICAL_URL}/${locale}${item.url}`,
      name: item.label,
    },
  })),
});
